import open from "./open.js"
import user_logged from "./user_logged.js"
import user_flag from "./user_flag.js"
import user_id from "./user_id.js"
import group from "./group.js"
import permission from "./permission.js"

/*

anyone
user_required
user_properties_required   // is_staff  // is_superadmin
groups_required
*/


function checkAuth(auth){


    const authorizations_computed = []

    // if (ENVIRONMENT === "development") {
    //     authorizations_computed.push(true)
    // }

    // console.log("🔐 checking auth", auth)

    if (!auth) {
        console.log("❌ no auth given...")
        return false
    }

    if ("open" in auth){
        authorizations_computed.push(open( auth.open ))
    }

    if ("user_logged" in auth){
        authorizations_computed.push(user_logged(auth.user_logged))
    }

    if ("group" in auth){
        authorizations_computed.push(group(auth.group))
    }

    if ("user_flag" in auth){
        authorizations_computed.push(user_flag(auth.user_flag))
    }
    if ("user_id" in auth){
        authorizations_computed.push(user_id(auth.user_id))
    }
    if ("permission" in auth){
        authorizations_computed.push(permission(auth.permission))
    }


    // 

   
    if (authorizations_computed.includes(true)) 
        return true

    return false
}





export {checkAuth}
